'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserId = undefined;

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _reselect = require('reselect');

var _getUser = require('./getUser');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getUserId = exports.getUserId = (0, _reselect.createSelector)(_getUser.getUser, (0, _get2.default)('user_id'));


//////////////////
// WEBPACK FOOTER
// ./js/selectors/userSelectors/getUserId.js
// module id = 339
// module chunks = 2 3